exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#content-image-dropzone[data-v-61f6075d]{min-height:126px}#content-image-add-files[data-v-61f6075d]{padding-top:40px}.dz-uploaded-file[data-v-61f6075d]{cursor:default}", ""]);

// exports
